import axios from 'axios';

import IJobBoardDTO from '../types/IJobBoardDTO';
import IJobBoardPayload from '../types/IJobBoardPayload';
import IJobBoardShareAccountPayload from '../types/IJobBoardShareAccountPayload';

export const addJobBoardAccounts = (payload: IJobBoardPayload) =>
  axios.post('candidatesearch/api/job-board-search-account', payload);

export const getJobBoardByJBName = (jobBoardName: string, email?: string) =>
  axios.get(`candidatesearch/api/job-board-search-account/${jobBoardName}`, {
    params: {
      email,
      accountList: 'all',
    },
  });

export const getJobBoardDetailsByName = (jobBoardName: string, accountId: string, email?: string) =>
  axios.get(
    `candidatesearch/api/job-board-search-account/${jobBoardName}/details?refreshAccount=${accountId}`,
    { params: { email, accountList: 'all' } }
  );

export const addCareerBuilderEdge = () =>
  axios.get('candidatesearch/api/career-builder/init-oauth?publicAccount=false');

export const updateJobBoardAccounts = (payload: IJobBoardDTO) =>
  axios.put('candidatesearch/api/job-board-search-account', payload);

export const deleteJobBoardAccounts = (id: string) =>
  axios.delete(`candidatesearch/api/job-board-search-account/${id}`);

export const regenerateDiceToken = (id: string) =>
  axios.get(`candidatesearch/api/job-board-search-account/regenerate-dice-token/${id}`);

export const shareJobBoardAccounts = (payload: IJobBoardShareAccountPayload) =>
  axios.put('candidatesearch/api/job-board-search-account/share', payload);
